import { Button, Modal } from "react-bootstrap";

export default function NFSeModalEmissaoErro({ show, errorData, handleClose }:iProps) {
    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            onHide={() => { handleClose() }}
            // centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <b>Erro</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <textarea id="modal_erro" className='form-control' style={{height: "512px"}} value={errorData} readOnly></textarea>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => { handleClose() }}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}
interface iProps {
    show: boolean
    errorData: any
    handleClose: any
}
